import { lazy } from "react";
import { PATHS } from "@/lib/router";

const EsgDashboardPage = lazy(() => import("./pages/EsgDashboardPage"));

export const esgDashboardRoutes = [
  {
    path: PATHS.ANALYTICS_DASHBOARD,
    element: <EsgDashboardPage />,
    handle: { permission: { resource: "esg_dashboard", action: "view" } },
  },
];
